import { useDispatch, useSelector } from "react-redux";

import { useEffect } from 'react';

import { log as actionsLog } from "../store/actions";

const { getLog } = actionsLog;

const Log = () => {

    const dispatch = useDispatch();

    let items = useSelector(store => store.log.items);

    useEffect(() => {
        dispatch(getLog());
    }, []);

    const getClassBySignal = ({ signal }) => {
        return signal == 1 ? 'text-green-300' : 'text-red-300';
    };

    return (

        <div className="flex flex-col p-2 overflow-hidden font-mono">
            
            {items.map(item => <div className={`${getClassBySignal(item)} text-sm`}><span className="text-gray-400 mr-2">{ item.date }</span>{ item.message }</div>)}

        </div>

    );
}

export default Log;